import styled from 'styled-components';
import { useState,useEffect } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import api from "../axios.js";
import fondo from '../imgs/fondoActiva.webp'
import Button from '@mui/material/Button';
import LoginIcon from '@mui/icons-material/Login';

const Container=styled.div`
	background-image:url(${fondo});
	height:100vh;
	width:100vw;
	background-size:cover;
	background-repeat:no-repeat;
	background-color:black;
	background-position:Center;
	display:flex;
	justify-content:center;
	align-items:center

`;

let Msj=styled.div`
	font-size:25px;
	height:64%;
	width:61%;	
	position:relative;
	font-family: "Poppins", sans-serif;
	background: rgba(1, 1, 1, 0.6); 
  	border-radius: 10px;
  	backdrop-filter: blur(5px);
 	box-shadow: 0 4px 30px #26125D; 
  	border: 1px solid #26125D; 
  	text-align: center;
  	color: white;
  	display:flex;
  	flex-direction:column;
  	align-items:center;
  	justify-content:center;

`;

const Logo=styled.div`
		position:absolute;
		top:20px;
		left:55px
`;


export default function Activa(){
	let params=useParams();
	let {id}=params;
	let [mensaje,setMensaje] = useState("Enviando activacion...");
	let [send,setSend] = useState(false);
	let navigate=useNavigate();

	useEffect(()=>{
		let activacion=async(id)=>{
			
		try {
				await api.post(`/usuario/activa?id=${id}`);
				setMensaje("Tu cuenta a sido activada de manera exitosa!");
				setSend(true);
			}catch(err){setMensaje('error al activar tu cuenta');console.log(err)}
		};
		activacion(id)
	},[id])

	let toHome=()=>{
			navigate("/")
	}

	return(
		<Container>
			
			<Msj> 
				<Logo><b>Playlan</b>myn™</Logo>
				<div>{mensaje}</div>
				{send?<Button onClick={toHome} variant="standard" size="large"  sx={{'&:hover':{backgroundColor: 'white',color:"#26125D"},color:"green"}} endIcon={<LoginIcon />} >ir a tienda</Button>:null}
			</Msj>
		</Container>
	)

}

